<template>
  <div class="container">
    <el-form
      ref="form"
      class="login-form"
      label-position="left"
      :model="form"
      :rules="rules"
    >
      <el-form-item prop="username" style="margin-top: 0px;">
        <el-input
          v-model.trim="form.username"
          placeholder="请输入手机号码登录"
          prefix-icon="el-icon-mobile-phone"
          maxlength="11"
          tabindex="1"
          type="text"
          disabled
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          :key="passwordType"
          v-model.trim="form.password"
          placeholder="请输入短信验证码"
          prefix-icon="el-icon-lock"
          maxlength="4"
          tabindex="2"
        >
          <template v-if="passwordType === 'password'" #suffix>
            <div style="margin-right: 25px;">
              <el-button type="text" @click="handleGetCode">{{ codeMsg }}</el-button>
            </div>
          </template>
          <template v-else #suffix>
            <div style="margin-right: 50px;color: #1E90FF">
              {{ form.second }} S
            </div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <JcRange
          :key="key"
          status="status"
          :success-fun="()=>status=true"
          :error-fun="()=>status=false">
        </JcRange>
      </el-form-item>
      <el-button
        class="login-btn"
        :loading="loading"
        type="primary"
        @click="handleLogin"
      >
        登录
      </el-button>
    </el-form>
  </div>
</template>

<script>
import img1 from '@/assets/images/back/left_img-fba58be9.png'
import { getCodeInfo, getPermissionPoint, getSmsCode } from '@/api/login'
import { setToken } from '@/api/auth'
import { urlParam } from '@/utils/url'
import JcRange from '@/components/jcRange.vue'

export default {
  name: 'LoginComponent',
  components: {
    // HelloWorld,
    // FixedHeader,
    JcRange
  },
  props: {
    myPhone: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户名不能为空'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      // if (!isPassword(value)) {
      //   callback(new Error('验证码不能少于4位'))
      // } else {
      //   callback()
      // }
      if (value === '') {
        callback(new Error('验证码不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        username: '',
        password: '',
        verificationCode: '',
        second: 1
      },
      rules: {
        username: [
          {
            required: true,
            trigger: 'blur',
            validator: validateUsername
          }
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePassword
          }
        ]
        /* verificationCode: [
          {
            required: true,
            trigger: 'blur',
            message: '验证码不能空',
          },
        ], */
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      timer: 0,
      previewText: '',
      url: img1,
      centerDialogVisible: false,
      iconStatus: 'success',
      iconTitle: '登录成功',
      iconTips: '请关闭所有Word，并重新打开。可关闭本网页。',
      codeMsg: '获取验证码',
      param: {},
      unid: '',
      phone: '',
      status: false,
      key: Date.now()
    }
  },
  watch: {
    // //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
    myPhone(newValue) {
      this.form.username = this.myPhone
    }
  },
  created() {
  },
  mounted() {
    this.form.username = this.myPhone
    // 获取链接的参数
    this.param = urlParam
  },
  methods: {
    async handleSendCode() {
      // 定义参数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'id': this.param.code,
        'phone': this.form.username,
        'timestamp': timestamp
      }
      getSmsCode(params).then((res) => {
        console.log('获得返回数据1111')
        console.log(res)
        console.log(res['code'])
        if (res['code'] === 200) {
          this.$message({
            message: '短信验证码已发送',
            type: 'success'
          })
          this.unid = res['data']['unid']
        } else {
          // 验证码发送失败
          const errorMsg = `发送失败：${res['msg']}`
          this.$message({
            message: errorMsg,
            type: 'error'
          })
        }
      })
    },
    handleGetCode() {
      // eslint-disable-next-line eqeqeq
      if (this.form.username == '' || this.form.username === undefined || this.form.username.length !== 11) {
        this.$message({
          message: '手机号不能为空，且为11位长度',
          type: 'error'
        })
        return
      }
      this.handleSendCode().then(result => {
        // this.timer = setInterval(() => {
        //   console.log(result)
        // }, 5000)
        console.log(result)
      })
      this.passwordType = ''
      this.form.second = 60
      this.timer = setInterval(() => {
        this.form.second--
        if (this.form.second === 0) {
          this.form.second = 0
          this.passwordType = 'password'
          this.codeMsg = '重新获取'
          clearInterval(this.timer)
        }
      }, 1000)
    },
    handleGetPermission() {
      // Math.random()*(max-min)+min),生成10-100的随机数
      const timestamp = new Date().getTime().toString() + Math.round(Math.random() * 90 + 10).toString()
      var params = {
        'phone': this.form.username,
        'timestamp': timestamp
      }
      getPermissionPoint(params).then((res) => {
        console.log('获得返回数据33')
        console.log(res)
        if (res['code'] === 200) {
          // 验证通过，登录成功
          console.log('验证通过')
          this.$message({
            message: '登录验证成功',
            type: 'success'
          })
          // 保存本地
          const str = this.form.username
          localStorage.setItem('booleardaPhone', str)
          // 保存token
          const token = res['data']['token']
          setToken(token)
          // 触发父组件事件
          this.$emit('handleChangeLogin', '0')
          console.log('子组件事件点击')
        } else {
          // 认证失败，登录失败
          this.$message.error('登录失败，请重试')
          // const errorMsg2 = `${res['msg']}`
          // this.centerDialogVisible = true
          // this.iconStatus = 'error'
          // this.iconTitle = '验证失败'
          // this.iconTips = errorMsg2
          // // this.$message({
          // //   message: errorMsg,
          // //   type: 'error'
          // // })
        }
      })
      // 需要重置页面框的值，否则会留下上次的记录
      this.resetLogin()
    },
    handleLogin() {
      // 判断活动验证码
      if (!this.status) {
        this.$message.error('请先拖动滑块验证')
        return
      }
      // 校验数据完整
      console.log('手机号为' + this.form.username.length)
      // eslint-disable-next-line eqeqeq
      if (this.form.username == '' || this.form.username === undefined || this.form.username.length !== 11) {
        this.$message({
          message: '手机号不能为空，且为11位长度',
          type: 'error'
        })
        this.resetLogin()
        return
      }
      if (this.form.password === '' || this.form.password === undefined || this.form.password.length !== 4) {
        this.$message({
          message: '验证码不能为空，且为4位长度',
          type: 'error'
        })
        this.resetLogin()
        return
      }
      // 验证码是否有效
      var paraSms = {
        'id': this.unid,
        'phone': this.form.username,
        'code': this.form.password
      }
      getCodeInfo(paraSms).then((res) => {
        console.log('获得返回数据22')
        console.log(res)
        // console.log(res['code'])
        if (res['code'] === 200) {
          console.log('验证码有效')
          this.handleGetPermission()
        } else {
          const errorMsg = `${res['msg']}`
          this.$message({
            message: errorMsg,
            type: 'error'
          })
        }
      })
      this.resetLogin()
    },
    resetLogin() {
      // 重新初始化登录框的参数设置
      this.form.password = ''
      this.form.second = 0
      this.passwordType = 'password'
      this.codeMsg = '获取验证码'
      clearInterval(this.timer)
      // 通过修改key，来重新渲染滑块子组件
      this.key = Date.now()
      this.status = false
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  text-align: center;
}
.login-form{
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 40px;
}
.login-btn {
  display: inherit;
  width: 100%;
  height: 50px;
  margin-top: 10px;
  border: 0;

  &:hover {
    opacity: 0.9;
  }
}
</style>
